
<template>
  <div id="app">
  
    <router-view/>
  </div>
</template>
<script>
export default {
   created () {
    // 在页面加载时读取sessionStorage
    let _this = this;
    if (sessionStorage.getItem('store')) {
      _this.$store.replaceState(Object.assign({}, _this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
    }
    // 在页面刷新时将store保存到sessionStorage里
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(_this.$store.state))
    })
  },
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  
}
html,body,#app{
padding: 0px;
  margin: 0px; 
  height: 100vh;
  overflow-y: hidden;
  min-width: 1200px;
}


#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
/* 去除侧边弹框点击后出现黑色边框情况 */
.el-drawer:focus {
  outline: none;
}
</style>
